import { render, staticRenderFns } from "./competitor.vue?vue&type=template&id=6ed5a03a"
import script from "./competitor.vue?vue&type=script&lang=js"
export * from "./competitor.vue?vue&type=script&lang=js"
import style0 from "./competitor.vue?vue&type=style&index=0&id=6ed5a03a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports